import ServiceBase from './serviceBase';
import {
  DashboardFilter,
  DashboardList,
  DashboardOverview,
  DashboardOverviewFilter,
  Member,
} from './types/Dashboard';

class DashboardService extends ServiceBase {
  list = async (filter: DashboardFilter): Promise<DashboardList> =>
    this.post<DashboardList>('dashboard', filter);

  members = async (): Promise<Member[]> => this.get<Member[]>('dashboard/members');

  getOverviewData = async (filter: DashboardOverviewFilter): Promise<DashboardOverview> =>
    this.post<DashboardOverview>('dashboard/overview', filter);
}

const dashboardService = new DashboardService();

export default dashboardService;
